import { MouseEvent } from "react";
import { useAdminLang } from "./i18n";

// Markup follows the Xintra template sidebar (index.html, app-sidebar) exactly;
// only the menu items are the resume sections. Opening sub menus, the active
// item, collapsing and the mobile menu are all handled by defaultmenu.min.js.
// Links are normal <a href> like in the template (full page load per page).
const prevent = (e: MouseEvent) => e.preventDefault();

// heroicons (outline, 24px) — the same icon set the template uses
const ICONS = {
  home: "m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25",
  user: "M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z",
  code: "M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5",
  photo: "m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z",
  briefcase: "M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z",
  academic: "M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5",
  envelope: "M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75",
  users: "M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z",
  globe: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418",
};

type IconName = keyof typeof ICONS;

interface MenuLink {
  title: string;
  href: string;
  icon: IconName;
  newTab?: boolean;
  children?: { title: string; href: string }[];
}

interface MenuGroup {
  category: string;
  items: MenuLink[];
}

// Same order as the sections of the public site.
const MENU: MenuGroup[] = [
  {
    category: "اصلی",
    items: [{ title: "داشبورد", href: "/admin", icon: "home" }],
  },
  {
    category: "محتوای رزومه",
    items: [
      { title: "درباره من", href: "/admin/about", icon: "user" },
      {
        title: "مهارت‌ها",
        href: "/admin/skills",
        icon: "code",
        children: [
          { title: "لیست مهارت‌ها", href: "/admin/skills" },
          { title: "افزودن مهارت", href: "/admin/skills/add" },
        ],
      },
      {
        title: "نمونه‌کارها",
        href: "/admin/portfolio",
        icon: "photo",
        children: [
          { title: "لیست نمونه‌کارها", href: "/admin/portfolio" },
          { title: "افزودن نمونه‌کار", href: "/admin/portfolio/add" },
        ],
      },
      {
        title: "سوابق کاری",
        href: "/admin/experience",
        icon: "briefcase",
        children: [
          { title: "لیست سوابق کاری", href: "/admin/experience" },
          { title: "افزودن سابقه کاری", href: "/admin/experience/add" },
        ],
      },
      {
        title: "سوابق تحصیلی",
        href: "/admin/education",
        icon: "academic",
        children: [
          { title: "لیست سوابق تحصیلی", href: "/admin/education" },
          { title: "افزودن سابقه تحصیلی", href: "/admin/education/add" },
        ],
      },
    ],
  },
  {
    category: "ارتباطات",
    items: [{ title: "پیام‌های تماس", href: "/admin/messages", icon: "envelope" }],
  },
  {
    category: "مدیریت",
    items: [
      {
        title: "کاربران",
        href: "/admin/users",
        icon: "users",
        children: [
          { title: "لیست کاربران", href: "/admin/users" },
          { title: "افزودن کاربر", href: "/admin/users/add" },
        ],
      },
    ],
  },
  {
    category: "سایت",
    items: [{ title: "مشاهده سایت", href: "/", icon: "globe", newTab: true }],
  },
];

const MenuIcon = ({ name }: { name: IconName }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 side-menu__icon" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d={ICONS[name]}></path>
  </svg>
);

export default function AdminSidebar() {
  const { t } = useAdminLang();

  return (
    <aside className="app-sidebar sticky" id="sidebar">
      <div className="main-sidebar-header">
        <a href="/admin" className="header-logo">
          <img src="/assets/images/brand-logos/desktop-logo.png" alt="logo" className="desktop-logo" />
          <img src="/assets/images/brand-logos/toggle-dark.png" alt="logo" className="toggle-dark" />
          <img src="/assets/images/brand-logos/desktop-dark.png" alt="logo" className="desktop-dark" />
          <img src="/assets/images/brand-logos/toggle-logo.png" alt="logo" className="toggle-logo" />
          <img src="/assets/images/brand-logos/toggle-white.png" alt="logo" className="toggle-white" />
          <img src="/assets/images/brand-logos/desktop-white.png" alt="logo" className="desktop-white" />
        </a>
      </div>

      <div className="main-sidebar" id="sidebar-scroll">
        <nav className="main-menu-container nav nav-pills flex-column sub-open">
          <div className="slide-left" id="slide-left">
            <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24">
              <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path>
            </svg>
          </div>
          <ul className="main-menu">
            {MENU.map((group) => [
              <li className="slide__category" key={group.category}>
                <span className="category-name">{t(group.category)}</span>
              </li>,
              ...group.items.map((item) =>
                item.children ? (
                  <li className="slide has-sub" key={item.href}>
                    <a href="#" onClick={prevent} className="side-menu__item">
                      <MenuIcon name={item.icon} />
                      <span className="side-menu__label">{t(item.title)}</span>
                      <i className="ri-arrow-down-s-line side-menu__angle"></i>
                    </a>
                    <ul className="slide-menu child1">
                      <li className="slide side-menu__label1">
                        <a href="#" onClick={prevent}>{t(item.title)}</a>
                      </li>
                      {item.children.map((child) => (
                        <li className="slide" key={child.href}>
                          <a href={child.href} className="side-menu__item">{t(child.title)}</a>
                        </li>
                      ))}
                    </ul>
                  </li>
                ) : (
                  <li className="slide" key={item.href}>
                    <a
                      href={item.href}
                      className="side-menu__item"
                      target={item.newTab ? "_blank" : undefined}
                      rel={item.newTab ? "noreferrer" : undefined}
                    >
                      <MenuIcon name={item.icon} />
                      <span className="side-menu__label">{t(item.title)}</span>
                    </a>
                  </li>
                )
              ),
            ])}
          </ul>
          <div className="slide-right" id="slide-right">
            <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24">
              <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
            </svg>
          </div>
        </nav>
      </div>
    </aside>
  );
}
